// ChatGPT API Service
// این سرویس از طریق PHP Backend به ChatGPT متصل می‌شود

// آدرس PHP Backend
const PHP_API_URL = '/api/chat.php'; // برای production آدرس کامل سرور را بگذارید

export const sendMessageToChatGPT = async (message, conversationHistory = []) => {
  try {
    const response = await fetch(PHP_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        message: message,
        history: conversationHistory
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'خطا در ارتباط با سرور');
    }

    const data = await response.json();
    
    if (data.success && data.message) {
      return data.message;
    } else {
      throw new Error('پاسخ دریافتی معتبر نیست');
    }
  } catch (error) {
    console.error('Error calling ChatGPT API:', error);
    throw error;
  }
};

// تابع کمکی برای تبدیل تاریخچه پیام‌ها به فرمت API
export const formatMessagesForAPI = (messages) => {
  return messages.map(msg => ({
    role: msg.role,
    content: msg.content
  }));
};

// پاسخ نمونه برای زمانی که API کلید ندارید
export const getMockResponse = (message) => {
  const responses = {
    'default': `این یک پاسخ نمونه است. برای دریافت پاسخ‌های واقعی از ChatGPT:\n\n1️⃣ کلید API از OpenAI دریافت کنید (https://platform.openai.com/api-keys)\n2️⃣ کلید را در فایل src/services/chatService.js قرار دهید\n3️⃣ در App.js از تابع sendMessageToChatGPT استفاده کنید\n\nسوال شما: "${message}"\n\nمن می‌توانم درباره موارد زیر به شما کمک کنم:\n\n🏖️ مقاصد گردشگری ایران و جهان\n✈️ برنامه‌ریزی سفر و چک‌لیست\n🏨 معرفی هتل‌ها و اقامتگاه‌ها\n🍽️ رستوران‌ها و غذاهای محلی\n📸 جاذبه‌های دیدنی\n💡 نکات و توصیه‌های سفر`,
    'شمال': 'شمال ایران یکی از زیباترین مقاصد گردشگری است! 🌲\n\n🏔️ رامسر: برای طبیعت زیبا و هوای معتدل\n🌊 چالوس: برای ساحل و رستوران‌های دریایی\n🌳 ماسوله: برای روستای پلکانی و طبیعت بکر\n🏞️ تالش: برای آبشارها و مناظر زیبا\n\nبهترین زمان سفر: بهار و تابستان',
    'دبی': 'دبی مقصد محبوب گردشگری است! 🏙️\n\n📋 مدارک مورد نیاز:\n✅ پاسپورت معتبر\n✅ ویزای توریستی\n✅ رزرو هتل\n✅ بیمه مسافرتی\n\n🏙️ جاهای دیدنی:\n🗼 برج خلیفه\n🏖️ جمیرا بیچ\n🛍️ دبی مال\n⛲ فواره‌های رقصان',
    'اصفهان': 'اصفهان نصف جهان! 🕌\n\n🎨 جاهای دیدنی:\n⭐ میدان نقش جهان\n🕌 مسجد شاه و شیخ لطف‌الله\n🌉 سی‌و‌سه‌پل و خواجو\n🏛️ کاخ چهلستون\n\n🍽️ غذاهای محلی:\n• بریان\n• خورشت ماست\n• گز اصفهانی'
  };

  const lowerMessage = message.toLowerCase();
  for (const [key, response] of Object.entries(responses)) {
    if (lowerMessage.includes(key) && key !== 'default') {
      return response;
    }
  }
  
  return responses.default;
};
